module.exports = ".loader-hidden {\n    visibility: hidden;\n}\n.loader-overlay {\n    position: absolute;\n    width:100%;\n    top:0;\n    left: 0;\n    opacity: 1;\n    z-index: 500000;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/loader/loader.component.css
// module id = 1244
// module chunks = 10